import { useEffect, useState } from 'react'

// Значение, отстающее от ввода на delay: печать не должна дёргать бэк на каждый
// символ (палитра и страница поиска).
export function useDebouncedValue<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState(value)
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(t)
  }, [value, delay])
  return debounced
}
